export type Sort = (typeof sorts)[number];
export const sorts = ["name-a-z", "name-z-a", "biggest-first", "smallest-first"] as const;
